import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * A phone: narrower than MUI's `sm` breakpoint, or a touch screen shorter than 500px (a phone
 * held sideways). Tablets and desktops are neither.
 */
export const PHONE_MEDIA_QUERY = '(max-width:599.95px), (max-height:500px) and (pointer:coarse)';

/**
 * True on a phone. Read on the very first render (`noSsr`), so a page that is not built for
 * phones never flashes before its desktop-only screen replaces it.
 */
export function useIsPhone(): boolean {
  return useMediaQuery(PHONE_MEDIA_QUERY, { noSsr: true });
}
